var spinner 	='<div class="spinner mx-auto"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div><div class="rect6"></div><div class="rect7"></div><div class="rect8"></div><div class="rect9"></div><div class="rect10"></div></div>';
// Encoding: UTF-8
$(document).ready(function() {

	// Button Clicks
	$('.widget-items-items .url-control, .widget.items.items .url-control').click(function(event){
		var tab					= event.currentTarget.className.split(' ')[3];
		if (event.currentTarget.nodeName === "SELECT") {
			return;
		}
		window.location.href	= add_url_param(event.currentTarget.name,event.currentTarget.value,'titel');
	});

	// Change
	$('.widget-items-items .url-control, .widget.items.items .url-control').change(function(event){
		var tab					= event.currentTarget.className.split(' ')[3];
		var value				= event.currentTarget.value;
		window.location.href	= add_url_param(event.currentTarget.name,value,'titel');
	});
	// Klick Events (<a>)

	init_load_more();
	init_letters();

	// window.addEventListener('popstate', function(event) {
	// 	var object_data	= event.state;
	// 	if (object_data != null && object_data.hasOwnProperty("widget_id")) {
	// 		var widget_id		= object_data.widget_id;
	// 		var content			= object_data.html;
	// 		var widget_list		= $("#"+widget_id).find(".itemlist");
	// 		console.log(widget_list);
	// 		$(widget_list).html(content);
	// 		var lazy_threshold	= window.innerHeight;
	// 		$("img[data-src]").unveil(lazy_threshold);
	// 	} else {
	// 		console.log("reset");
	// 	}
	// 	init_load_more();
	// 	// load widget id from data-object, set itemlist to given html
	// });
});

/**
 * lazy load after every ajax request
 * */
$(document).ajaxComplete(function(event, request, settings ) {
	if (request.status == 200) {
		init_load_more();
	}
});


function get_url_value(ist_aktiv,url_type,id_element) {
	const uri		= new URI();
	const query		= uri.query(true);
	var url_kurz	= url_type.substring(0,2) + '-';
	var given_id	= id_element.replace(url_kurz,"");
	// welche url-parameter sind vorhanden? für url_type
	if (ist_aktiv === 'inaktiv') {
		if (query[url_type] === undefined) {
			var value	= id_element.replace(url_kurz,"");
		} else if (query[url_type] != 0) {
			var value	= query[url_type] + '_' + given_id;
		} else {
			var value	= id_element.replace(url_kurz,"");
		}
	} else {
		// ziehe aktuelle auswahl vom param ab für url_type
		if (query[url_type] === undefined || query[url_type] == given_id) {
			var value	= "0";
		} else {
			var value	= query[url_type].replace(given_id,'');
		}
	}
	value		= value.replace('__','_');
	return value;
}

function add_url_param(name,value,tab) {
	const uri		= new URI();
	const query		= uri.query(true);
	query[name]		= value;
	query["page"]	= 1;
	query["type"]	= tab;
	uri.query(query);
	uri.hash("#itemlist");
	return uri.toString();
}

function init_load_more() {
	// detail-pages
	$('.widget-items-items .url-control-span').click(function(event) {
		var url					= event.currentTarget.dataset.target;
		// var widget_id			= $(this).closest(".widget").attr("id");
		// var obj_params_set		= get_url_params_fragments(url);
		// var obj_params_get		= get_url_hashes();
		// var string_hist_push	= merge_params(obj_params_set,obj_params_get);
		// var url_front			= window.location.href.replace(/#.+/,"");
		// AJAX request
		var liste_body			= $(this).closest('.widget.items.items').find('.itemlist');
		$(liste_body).load(url, function(html, status_txt, xhr) {
			// if (status_txt == "success") {
			// 	var dataObject = {
			// 		html: html,
			// 		activeLinkId: url,
			// 		widget_id: widget_id
			// 	};
			// 	history.pushState(dataObject, null, url_front + '#' + string_hist_push);
			// }
		});
		return false;
	});
	// widgets
	$('.widget.items.items .url-control-span:not(.widget-items-items .url-control-span)').click(function(event) {
		var url					= event.currentTarget.dataset.target;
		// var widget_id			= $(this).closest(".widget").attr("id");
		// var obj_params_set		= get_url_params_fragments(url);
		// var obj_params_get		= get_url_hashes();
		// var string_hist_push	= merge_params(obj_params_set,obj_params_get);
		// var url_front			= window.location.href.replace(/#.+/,"");
		// AJAX request
		var liste_body			= $(this).closest('.itemlist-more');
		$(liste_body).load(url, function(html, status_txt, xhr) {
			// if (status_txt == "success") {
			// 	var dataObject = {
			// 		html: html,
			// 		activeLinkId: url,
			// 		widget_id: widget_id
			// 	};
			// 	history.pushState(dataObject, null, url_front + '#' + string_hist_push);
			// }
		});
		return false;
	});
	// widgets (categories)
	$('.widget.items.categories .url-control-span:not(.widget-items-items .url-control-span)').click(function(event) {
		var url					= event.currentTarget.dataset.target;
		// var widget_id			= $(this).closest(".widget").attr("id");
		// var obj_params_set		= get_url_params_fragments(url);
		// var obj_params_get		= get_url_hashes();
		// var string_hist_push	= merge_params(obj_params_set,obj_params_get);
		// var url_front			= window.location.href.replace(/#.+/,"");
		// AJAX request
		var liste_body			= $(this).closest('.itemlist-more');
		$(liste_body).load(url, function(html, status_txt, xhr) {
			// if (status_txt == "success") {
			// 	var dataObject = {
			// 		html: html,
			// 		activeLinkId: url,
			// 		widget_id: widget_id
			// 	};
			// 	history.pushState(dataObject, null, url_front + '#' + string_hist_push);
			// }
		});
		return false;
	});
	// Suche
	$('#search-result .url-control-span:not(.widget-items-items .url-control-span)').click(function(event) {
		var url					= event.currentTarget.dataset.target;
		// var widget_id			= $(this).closest(".widget").attr("id");
		// var obj_params_set		= get_url_params_fragments(url);
		// var obj_params_get		= get_url_hashes();
		// var string_hist_push	= merge_params(obj_params_set,obj_params_get);
		// var url_front			= window.location.href.replace(/#.+/,"");
		// AJAX request
		var liste_body			= $(this).closest('.itemlist-more');
		$(liste_body).load(url, function(html, status_txt, xhr) {
			// if (status_txt == "success") {
			// 	var dataObject = {
			// 		html: html,
			// 		activeLinkId: url,
			// 		widget_id: widget_id
			// 	};
			// 	history.pushState(dataObject, null, url_front + '#' + string_hist_push);
			// }
		});
		return false;
	});
	// A-Z-LinkListe
	$('.widget.items.itemlinks-az .url-control-span:not(.widget-items-items .url-control-span)').click(function(event) {
		var url					= event.currentTarget.dataset.target;
		// var widget_id			= $(this).closest(".widget").attr("id");
		// var obj_params_set		= get_url_params_fragments(url);
		// var obj_params_get		= get_url_hashes();
		// var string_hist_push	= merge_params(obj_params_set,obj_params_get);
		// var url_front			= window.location.href.replace(/#.+/,"");
		// AJAX request
		var liste_body			= $(this).closest('.itemlist-more');
		$(liste_body).load(url, function(html, status_txt, xhr) {
			// if (status_txt == "success") {
			// 	var dataObject = {
			// 		html: html,
			// 		activeLinkId: url,
			// 		widget_id: widget_id
			// 	};
			// 	history.pushState(dataObject, null, url_front + '#' + string_hist_push);
			// }
		});
		return false;
	});
}

function init_letters() {
	$(".alphabet-box a.letter").click(function() {
		event.preventDefault();
		var url		= "";
		var target	= $(this).attr("href").replace("?","");
		var w_id	= $(this).closest(".widget").attr("id").replace("widget_","");
		var list	= $(this).closest(".widget").find(".widget-body");
		var array	= target.split("=");
		$(list).load("/ajax/widget?widget_id=" + w_id + "&" + array[0] + "=" + array[1]);
		$(".alphabet-box a.letter").removeClass("active");
		$(this).addClass("active");
	});
}

function get_url_params_fragments(url) {
	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
	// we'll store the parameters here
	var obj = {};

	// if query string exists
	if (queryString) {

		// stuff after # is not part of query string, so get rid of it
		queryString = queryString.split('#')[0];

		// split our query string into its component parts
		var arr = queryString.split('&');

		for (var i = 0; i < arr.length; i++) {
			// separate the keys and the values
			var a = arr[i].split('=');

			// set parameter name and value (use 'true' if empty)
			var paramName = a[0];
			var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

			// (optional) keep case consistent
			paramName = paramName.toLowerCase();
			if (typeof paramValue === 'string') {
				paramValue = paramValue.toLowerCase();
			}

			// if the paramName ends with square brackets, e.g. colors[] or colors[2]
			if (paramName.match(/\[(\d+)?\]$/)) {

				// create key if it doesn't exist
				var key = paramName.replace(/\[(\d+)?\]/, '');
				if (!obj[key]) {
					obj[key] = [];
				}

				// if it's an indexed array e.g. colors[2]
				if (paramName.match(/\[\d+\]$/)) {
					// get the index value and add the entry at the appropriate position
					var index = /\[(\d+)\]/.exec(paramName)[1];
					obj[key][index] = paramValue;
				} else {
					// otherwise add the value to the end of the array
					obj[key].push(paramValue);
				}
			} else {
				// we're dealing with a string
				if (!obj[paramName]) {
					// if it doesn't exist, create property
					obj[paramName] = paramValue;
				} else if (obj[paramName] && typeof obj[paramName] === 'string'){
					// if property does exist and it's a string, convert it to an array
					obj[paramName] = [obj[paramName]];
					obj[paramName].push(paramValue);
				} else {
					// otherwise add the property
					obj[paramName].push(paramValue);
				}
			}
		}
	}

	return obj;
}

function get_url_hashes() {
	var vars = {}, hash;
	if (window.location.href.indexOf('?') > 0) {
		var hashes			= window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	} else {
		var hashes			= window.location.href.slice(window.location.href.indexOf('#') + 1).split('&');
	}
	for(var i = 1; i < hashes.length; i++) {
		hash				= hashes[i].split('=');
		vars[hash[0]]		= hash[1];
	}
	return vars;
}

function merge_params(obj_set,obj_get) {
	var str_return	= "";
	var obj_merged	= Object.assign({},obj_get,obj_set);
	for (var key in obj_merged) {
		str_return	+= key + "=" + obj_merged[key] + "&";
	}

	return str_return.slice(0,-1);
}